import React, { useEffect, useState } from 'react'
import {
  List,
  Datagrid,
  TextField,
  TextInput,
  useTranslate,
  useResourceContext,
  useResourceDefinitions,
  useListController,
  useStore,
} from 'react-admin'
import { Container } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { ListViewActionsButtons } from 'src/components/uiElements/buttons/ListViewActionsButtons'
import { ListViewTopToolbar } from 'src/components/uiElements/CRUD/ListViewTopToolbar'

export function ProcessApplicationList(props) {
  const translate = useTranslate()
  const { setSort, isFetching } = useListController()
  const [isSorting, setIsSorting] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [permissionsStore, setPermissionsStore] = useStore('currentResource', '{}')
  const [permissions, setPermissions] = useState(null)
  const propsResource = useResourceDefinitions()
  const resourceName = useResourceContext()

  useEffect(() => {
    setPermissionsStore(JSON.stringify(propsResource[resourceName]))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propsResource, resourceName])

  useEffect(() => {
    if (permissionsStore) {
      setPermissions(JSON.parse(permissionsStore))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissionsStore])

  useEffect(() => {
    if (isSorting && isFetching) {
      setIsLoading(true)
    } else if (isLoading && isSorting && !isFetching) {
      setIsLoading(false)
      setIsSorting(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSorting, isFetching])

  const onClickSort = (sort) => {
    setSort(sort)
    setIsSorting(true)
  }

  const hasPermissions = () => {
    return permissions?.options?.revision ||
      permissions?.hasShow ||
      permissions?.hasEdit ||
      permissions?.options?.delete
  }

  const processApplicationFilters = [
    <TextInput label={translate('ra.field.id')} source='id' defaultValue='' />,
    <TextInput label={translate('ra.field.endpoint')} source='endpoint' defaultValue='' />,
    <TextInput label={translate('ra.field.application_id')} source='application_id' defaultValue='' />,
    <TextInput label={translate('ra.field.client_id')} source='client_id' defaultValue='' />,
  ]
  return (
    <Container className='content'>
      <CardCommon title={translate('ra.entity.processApplication')}>
        <List {...props} component='div' filters={processApplicationFilters} actions={<ListViewTopToolbar hasCreate={permissions?.hasCreate} />}>
          <Datagrid rowClick='show' setSort={onClickSort} isLoading={isLoading}>
            <TextField label={translate('ra.field.id')} source='id' />
            <TextField label={translate('ra.field.endpoint')} source='endpoint' />
            <TextField label={translate('ra.field.application_id')} source='application_id' />
            {hasPermissions() && (
              <ListViewActionsButtons label={translate('ra.field.action')} fieldsName={['endpoint']} genderElement='masculine' />
            )}
          </Datagrid>
        </List>
      </CardCommon>
    </Container>
  )
}
